import { render, staticRenderFns } from "./CorrectionInVehicleDetails.vue?vue&type=template&id=5f86e1d3&scoped=true"
import script from "./CorrectionInVehicleDetails.vue?vue&type=script&lang=js"
export * from "./CorrectionInVehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./CorrectionInVehicleDetails.vue?vue&type=style&index=0&id=5f86e1d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86e1d3",
  null
  
)

export default component.exports